// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"TextDelimeter_paragraph__DhEXF","content":"TextDelimeter_content__g68bA","seeMessage":"TextDelimeter_seeMessage__1zun7"};